// 追従(CookiePolicy)の表示 // Display follow (CookiePolicy)
jQuery(function($) {

	if ( $('#cookiePolicy').length > 0 ) {
		var cookiePolicy = $('#cookiePolicy');
		cookiePolicy.hide();
		if(localStorage.getItem('cookieUse') === null) {

			// スクロール時の表示・非表示 // show/hide on scrolling
			$(window).on("scroll", dispAgree);

			// 同意ボタンクリック // click on the agree button
			$('#cookie_agree').on("click", function() {
				$(window).off("scroll", dispAgree);
				localStorage.setItem('cookieUse', 'agree');
				cookiePolicy.hide();
			})
		}

		//スクロールが100に達したらクッキー同意を表示 // Show cookie agreement when scroll reaches 100
		function dispAgree() {
			if ($(this).scrollTop() > 100) {
				cookiePolicy.fadeIn();
			} else {
				cookiePolicy.fadeOut();
			}
		}
	}


});

// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
	const offset = 40; // ← ヘッダーが無い場合の余白（お好みで調整）

	// var headerHeight = $('header').innerHeight() + 10; // ヘッダー追従の場合 // if header following
	var headerHeight = $('header').length ? $('header').innerHeight() + 10 : offset;
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// ページトップボタンの表示 // Display the page top button
jQuery(function($) {

	if ( $('#pageup').length > 0 ) {
		var topBtn = $('#pageup');
		topBtn.css("display", "none");
		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});


// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});


// ヘッダーアコーディオン
jQuery(function($) {
	$('.l-header-nav__item--parent > .l-header-nav__parent').on('click', function(e) {
		if ($('.l-header-nav').hasClass('is_open')) {
			e.preventDefault();
			var $subMenu = $(this).next('.l-header-nav__sub');
			$(this).parent().toggleClass('is_active');
			$subMenu.stop(true, false).slideToggle(200);
		}
	});
});

// ヘッダー固定
jQuery(function ($) {
	if ( $('.js-header-fixed').length > 0 ) {
		var headerHeight = $('.l-header').outerHeight();

		$(window).scroll(function() {
			var fvHeight = $('.js-header-fixed').outerHeight();
			var scrollTop = $(window).scrollTop();

			if (scrollTop > fvHeight) {
				$('.l-header').addClass('is-fixed');
			} else {
				$('.l-header').removeClass('is-fixed');
			}
		});
	}
});

// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});

jQuery(function ($) {
//二重送信抑制
	let submitBtn = $("input[type='submit'].wpcf7-submit");
	submitBtn.click(function () {
		$(this).css('pointer-events', 'none');
		$(this).css('opacity', '0.5');
	})
	// 入力項目にエラーがあったらボタン復活
	document.addEventListener('wpcf7invalid', function () {
		submitBtn.css('pointer-events', 'auto');
		submitBtn.css('opacity', '1');
	}, false);

});


// ヘッダー
jQuery(function ($) {
	if ( $('.js-header-fixed').length > 0 ) {
		var headerHeight = $('.l-header').outerHeight();

		$(window).scroll(function() {
			var fvHeight = $('.js-header-fixed').outerHeight();
			var scrollTop = $(window).scrollTop();

			if (scrollTop > fvHeight) {
				$('.l-header').addClass('is-fixed');
			} else {
				$('.l-header').removeClass('is-fixed');
			}
		});
	}
});




// サービスサイドバー
jQuery(function ($) {
  var $sidebarLinks = $(".c-sidebarNav__link");
  var $sections = $sidebarLinks.map(function () {
    var target = $($(this).attr("href"));
    if (target.length) {
      return target;
    }
  });

  // サイドバーリンククリック時のスムーススクロール
  // $sidebarLinks.click(function(e) {
  //   e.preventDefault();
  //   var href = $(this).attr("href");
  //   var target = $(href);
  //   if (target.length > 0) {
  //     var headerHeight = 80;
  //     var position = target.offset().top - headerHeight;
  //     $("html, body").animate({scrollTop: position}, 550, "swing");
  //   }
  // });

  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    var offset = 150;
    var currentSection = $sections.map(function () {
      if ($(this).offset().top - offset <= scrollTop) {
        return this;
      }
    });
    currentSection = currentSection[currentSection.length - 1];
    var id = currentSection && currentSection.length ? currentSection.attr("id") : "";
    if (id) {
      $sidebarLinks.removeClass("is-active");
      $sidebarLinks.filter('[href="#' + id + '"]').addClass("is-active");
    }
  });
});

jQuery(function ($) {
$('select.placeholder').on('change', function(){
	console.log($(this).val() );
	if($(this).val() == ""){//first_as_labelのvalueは空文字で出力される。
			$(this).css('color','#BCBBB8')
	} else {
			$(this).css('color','#333')
	}
});
});
